import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';

//iconos
import { Create, Add, Palette } from '@material-ui/icons';
import { Tooltip } from '@material-ui/core';

//tabla y card components
import GridContainer from 'components/Grid/GridContainer.js';
import GridItem from 'components/Grid/GridItem.js';
import Button from 'components/CustomButtons/Button.js';
import Card from 'components/Card/Card.js';
import CardBody from 'components/Card/CardBody.js';
import CardIcon from 'components/Card/CardIcon.js';
import CardHeader from 'components/Card/CardHeader.js';
import ReactTable from 'components/ReactTable/ReactTableV2.js';
import { cardTitle } from 'assets/jss/material-dashboard-pro-react.js';
import LoadingSpinner from 'components/Tvendo/Common/LoadingSpinner';

//servicios
import { wsGetAll } from 'services/WService.js';

//modal
import Modal from './Modal';
import { useModal } from 'hooks/useModal';
import { Toasty, useToasty } from 'hooks/Toasty';
import ButtonDelete from 'hooks/ButtonDelete';
import { WithApp } from 'contexts/appContext';
import { AllowedGuard } from 'components/Tvendo/Common/UserAction';
import { ConstantPermissions } from 'contexts/useConstant';

const styles = {
  cardIconTitle: {
    ...cardTitle,
    marginTop: '15px',
    marginBottom: '0px'
  }
};
const useStyles = makeStyles(styles);

const columns = [
  { Header: '#', accessor: 'num', excelEnabled: false, width: 180 },
  { Header: 'Código Color', accessor: 'code', width: 180 },
  { Header: 'Tipo', accessor: 'tipo', width: 150 },
  { Header: 'Descripción', accessor: 'description' },
  { Header: '', accessor: 'actions', excelEnabled: false, width: 0 },
];

export default WithApp(function CustomerColor(props) {
  const classes = useStyles();

  const [model, setOpen] = useModal();
  const [notify, showNotify] = useToasty();
  const [colores, setColores] = useState([]);
  const [dataLoading, setDataLoading] = useState(false);

  async function loadColores() {
    setDataLoading(true);
    let response = await wsGetAll('ordm/customer-color');
    setDataLoading(false);
    if (response.success) setColores(response.data);
  }

  useEffect(() => {
    loadColores();
  }, []);

  return (
    <GridContainer>
      <Toasty action={notify} />
      <Modal model={model} setOpen={setOpen} showNotify={showNotify} reload={loadColores} />

      <GridItem xs={12}>
        <Card>
          <CardHeader icon>
            <AllowedGuard
              permission={ConstantPermissions.BASE_CUSTOMER_PORTFOLIO_BUREAUS_INDEX}
              component={
                <CardIcon color="primary">
                  <Palette style={{ color: 'white' }} />
                </CardIcon>
              }
            >
              <CardIcon
                onClick={() => setOpen({})}
                pointer="true"
                color={props.themeContext.buttonColorSuccess}
              >
                <Add />
              </CardIcon>
            </AllowedGuard>
            <h4 className={classes.cardIconTitle}>
              Colores del aplicativo {dataLoading && <LoadingSpinner />}
            </h4>
          </CardHeader>
          <CardBody>
            <ReactTable
              excelName="Colores del aplicativo"
              defaultWidth={1200}
              columns={columns}
              data={colores.map((color, i) => {
                return {
                  num: (
                    <div className="actions-right">
                      {i + 1}
                      <AllowedGuard permission={ConstantPermissions.BASE_CUSTOMER_PORTFOLIO_BUREAUS_INDEX}>
                        <Button
                          justIcon
                          round
                          simple
                          color="info"
                          onClick={() => setOpen(color)}
                          className="like"
                        >
                          <Create />
                        </Button>
                      </AllowedGuard>
                      <AllowedGuard permission={ConstantPermissions.BASE_CUSTOMER_PORTFOLIO_BUREAUS_INDEX}>
                        <ButtonDelete
                          entity="ordm/customer-color"
                          id={color.id}
                          reload={loadColores}
                        />
                      </AllowedGuard>
                    </div>
                  ),
                  muestra: (
                    <Tooltip title={color.code || ''}>
                      <div
                        style={{
                          width: 28,
                          height: 28,
                          borderRadius: 4,
                          border: '1px solid #ccc',
                          backgroundColor: color.code
                        }}
                      />
                    </Tooltip>
                  ),
                  code: (
                    <>
                      {color.code}
                      <Tooltip title={color.code || ''}>
                        <div
                          style={{
                            width: 28,
                            height: 28,
                            borderRadius: 4,
                            border: '1px solid #ccc',
                            backgroundColor: color.code
                          }}
                        />
                      </Tooltip>
                    </>
                  ),
                  tipo: color.type = 'C' ? 'Clientes' : color.type = 'P' ? 'Pedidos' : color.type,
                  description: color.description,
                  actions: ''
                };
              })}
            />
          </CardBody>
        </Card>
      </GridItem>
    </GridContainer>
  );
});
